import api from './api';

// Policy Documents CRUD
export const getPolicyDocuments = (params) => api.get('/v1/policy-documents', { params });
export const getPolicyDocument = (id) => api.get(`/v1/policy-documents/${id}`);
export const createPolicyDocument = (formData) => api.post('/v1/policy-documents', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const updatePolicyDocument = (id, data) => api.put(`/v1/policy-documents/${id}`, data);
export const deletePolicyDocument = (id) => api.delete(`/v1/policy-documents/${id}`);
export const getPolicyDocumentStats = (id) => api.get(`/v1/policy-documents/${id}/stats`);

// Quiz
export const getPolicyQuiz = (id) => api.get(`/v1/policy-documents/${id}/quiz`);
export const savePolicyQuiz = (id, data) => api.post(`/v1/policy-documents/${id}/quiz`, data);

// Assignments
export const getPolicyAssignments = (params) => api.get('/v1/policy-assignments', { params });
export const createPolicyAssignment = (data) => api.post('/v1/policy-assignments', data);
export const deletePolicyAssignment = (id) => api.delete(`/v1/policy-assignments/${id}`);
export const getPolicyAssignmentUsers = (id, params) =>
  api.get(`/v1/policy-assignments/${id}/users`, { params });
export const retryPolicyAssignmentForUser = (id, userId) =>
  api.post(`/v1/policy-assignments/${id}/users/${userId}/retry`);

// My Policy Tasks
export const getMyPolicyTasks = (params) => api.get('/v1/my-policy-tasks', { params });
export const getMyPolicyTask = (id) => api.get(`/v1/my-policy-tasks/${id}`);
export const openPolicyTask = (id) => api.post(`/v1/my-policy-tasks/${id}/open`);
export const startPolicyQuiz = (id) => api.post(`/v1/my-policy-tasks/${id}/quiz/start`);
export const submitPolicyQuiz = (id, data) => api.post(`/v1/my-policy-tasks/${id}/quiz/submit`, data);
